import StitchFeaturePage from "../../components/sections/StitchFeaturePage";

const features = [
  { title: "Cross-Platform Apps", desc: "React Native and Flutter builds that ship faster without sacrificing native quality." },
  { title: "Native Performance", desc: "iOS and Android optimization for speed, responsiveness, and long-session stability." },
  { title: "Backend Integration", desc: "Secure APIs, real-time sync, and role-based access connected to your core systems." },
  { title: "App Store Delivery", desc: "Submission, compliance, release planning, and post-launch support handled end-to-end." },
  { title: "Analytics & Retention", desc: "Event tracking, funnel analysis, and engagement loops that improve user lifetime value." },
  { title: "Scalable Architecture", desc: "Codebases structured for rapid iteration, new modules, and future product expansion." },
];

const AppDevelopment = () => (
  <StitchFeaturePage
    label="SOFTWARE & ENTERPRISE"
    title="Apps built for"
    titleAccent="adoption."
    subtitle="Mobile products designed for real users, backed by engineering discipline and measurable outcomes."
    features={features}
    ctaLabel="PLAN YOUR APP"
  />
);

export default AppDevelopment;